import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
/* ---------------- GLASS TILE ---------------- */
function GlassTile({ children, className = "" }) {
  return (
    <div
      className={`bg-white/40 backdrop-blur-xl border border-white/25 rounded-2xl shadow-lg ${className}`}
      style={{ WebkitBackdropFilter: "blur(14px) saturate(140%)" }}
    >
      {children}
    </div>
  );
}

/* ---------------- MAIN ADMIN PAGE ---------------- */
export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [expandedProduct, setExpandedProduct] = useState(null);
  const [expandedVariant, setExpandedVariant] = useState(null);
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [newProduct, setNewProduct] = useState({
    productName: "",
    productCode: "",
    productType: "",
    categoryId: "",
  });
  const [fulfillmentFlow, setFulfillmentFlow] = useState(null);
  const [loadingFlow, setLoadingFlow] = useState(true);

  const [showAddDesign, setShowAddDesign] = useState(false);

  const [newDesign, setNewDesign] = useState({
    designName: "",
    designCode: ""
  });

  const [designErrors, setDesignErrors] = useState({});

  const [errors, setErrors] = useState({});

  const [showAddVariant, setShowAddVariant] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);

  const [newVariant, setNewVariant] = useState({
    sku: "",
    color: "",
    size: ""
  });

  const [variantErrors, setVariantErrors] = useState({});

  const [showAddSellable, setShowAddSellable] = useState(false);
  const [selectedVariantId, setSelectedVariantId] = useState(null);
  const [showVariantImageUpload, setShowVariantImageUpload] = useState(false);

  const [variantImageFiles, setVariantImageFiles] = useState([]);

  const [designMaster, setDesignMaster] = useState([]);

  const [sellableForm, setSellableForm] = useState({
    displayName: "",
    storeSku: "",
    sellingPrice: 0,
    designs: [
      { designId: "", placement: "" }
    ]
  });

  const [sellableErrors, setSellableErrors] = useState({});

  /* -------- PLACEMENT OPTIONS -------- */
  const PLACEMENTS = [
    { value: "fr", label: "Front" },
    { value: "bk", label: "Back" },
    { value: "lp", label: "Left Pocket" },
    { value: "rp", label: "Right Pocket" },
    { value: "rs", label: "Right Shoulder" },
    { value: "ls", label: "Left Shoulder" }
  ];

  /* -------- PRODUCT CATEGORIES -------- */
  const categories = [
    { id: 1, name: "OTHER", bit_value: 0 },
    { id: 2, name: "REBEL_EKALP", bit_value: 1 },
    { id: 3, name: "DREAM_KALP", bit_value: 2 },
    { id: 4, name: "BUILD_KALP", bit_value: 4 },
    { id: 5, name: "GROW_KALP", bit_value: 8 },
    { id: 6, name: "FLOW_KALP", bit_value: 16 },
  ];

  const [selectedCategory, setSelectedCategory] = useState(null);

  const payload = {
    // other product fields...
    categoryBitValue: selectedCategory?.bit_value,
  };


  const validateVariant = () => {
    const e = {};

    if (!newVariant.sku || newVariant.sku.length < 3) {
      e.sku = "SKU is required (min 3 characters)";
    }

    setVariantErrors(e);
    return Object.keys(e).length === 0;
  };

  /* -------- ADD DESIGN ROW -------- */
  const addDesignRow = () => {
    setSellableForm({
      ...sellableForm,
      designs: [...sellableForm.designs, { designId: "", placement: "" }]
    });
  };
  /* -------- USED PLACEMENTS Prevent duplicate placement-------- */
  const usedPlacements = sellableForm.designs.map(d => d.placement);

  /* -------- GENERATE DISPLAY NAME Auto-generate display name-------- */
  const generateDisplayName = () => {
    return sellableForm.designs
      .map(d => {
        const design = designMaster.find(x => x.id == d.designId);
        return design ? design.designName : "";
      })
      .filter(Boolean)
      .join(" + ");
  };

  /* -------- VALIDATE PRODUCT -------- */
  const validateProduct = () => {
    const e = {};

    if (!newProduct.productName || newProduct.productName.length < 3)
      e.productName = "Product name must be at least 3 characters";

    if (!newProduct.productCode)
      e.productCode = "Product code is required";

    if (!/^[A-Z0-9_-]+$/.test(newProduct.productCode))
      e.productCode = "Only uppercase letters, numbers, _ and - allowed";

    if (!newProduct.productType)
      e.productType = "Product type is required";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* -------- UPDATE FULFILLMENT FLOW -------- */
  const updateFlow = async (mode) => {
    console.log("Updating flow to 👉", mode);

    setFulfillmentFlow(mode);

    await fetch("/api/admin/config/qikink-mode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ "QIKINK_MODE": mode }),
    });
  };

  const fetchProducts = async () => {
    try {
      const res = await fetch("/api/admin/getproducts");
      const data = await res.json();
      setProducts(data);
    } catch (e) {
      console.error("Failed to fetch products", e);
    }
  };

  useEffect(() => {
    const loadFlow = async () => {
      try {
        const res = await fetch("/api/admin/config/qikink-flow");
        const data = await res.json();

        console.log("FLOW FROM BACKEND 👉", data);

        const mode = data?.mode?.toString().trim().toUpperCase();

        if (mode === "QIKINK" || mode === "CUSTOM") {
          setFulfillmentFlow(mode);
        } else {
          console.error("Invalid flow from backend, defaulting to QIKINK:", mode);
          setFulfillmentFlow("QIKINK");
        }
      } catch (e) {
        console.error("Flow fetch failed:", e);
        setFulfillmentFlow("QIKINK");
      } finally {
        setLoadingFlow(false);
      }
    };

    loadFlow();
  }, []);




  /* -------- FETCH DESIGN MASTER -------- */
  useEffect(() => {
    fetch("/api/admin/designs")
      .then(res => res.json())
      .then(setDesignMaster);
  }, []);


  /* -------- FETCH PRODUCTS -------- */
  useEffect(() => {
    fetchProducts();
  }, []);


  return (
    <>
      <div className="min-h-screen px-6 pt-24 max-w-7xl mx-auto">

        <div className="flex justify-between items-center mb-10">
          <h1 className="text-3xl font-bold text-gray-800">
            Admin – Product Management
          </h1>

          {!loadingFlow && (
            <div className="flex items-center gap-6 bg-white/40 px-5 py-2 rounded-2xl border border-white/30">

              <span className="text-sm font-semibold text-gray-700">
                Fulfillment Flow:
              </span>

              <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
                <input
                  type="radio"
                  name="flow"
                  value="QIKINK"
                  checked={fulfillmentFlow === "QIKINK"}
                  onChange={() => updateFlow("QIKINK")}
                  className="accent-blue-600"
                />
                Qikink Flow
              </label>

              <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
                <input
                  type="radio"
                  name="flow"
                  value="CUSTOM"
                  checked={fulfillmentFlow === "CUSTOM"}
                  onChange={() => updateFlow("CUSTOM")}
                  className="accent-blue-600"
                />
                Custom Flow
              </label>
            </div>
          )}
        </div>


        {/* ---------------- PRODUCT LIST ---------------- */}
        <div className="space-y-6">
          {products.map(product => (
            <GlassTile key={product.id} className="p-6">
              {/* PRODUCT HEADER */}
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-semibold">{product.productName}</h2>
                  <p className="text-sm text-gray-600">Code: {product.productCode}</p>
                </div>

                <div className="flex items-center gap-4">
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={async () => {
                      if (!window.confirm("Delete this product and all its data?")) return;
                      await fetch(`/api/admin/products/${product.id}`, { method: "DELETE" });
                      setProducts(prev =>
                        prev.filter(p => p.id !== product.id)
                      );
                    }}
                  >
                    <Trash2 size={18} />
                  </button>
                  <button
                    className="text-blue-600 font-medium"
                    onClick={() =>
                      setExpandedProduct(expandedProduct === product.id ? null : product.id)
                    }
                  >
                    {expandedProduct === product.id ? "Hide Variants" : "View Variants"}
                  </button>
                </div>
              </div>


              {/* ---------------- VARIANTS ---------------- */}
              {expandedProduct === product.id && (
                <div className="mt-6 space-y-4">

                  {product.variants.map(variant => (
                    <GlassTile key={variant.id} className="p-4 bg-white/30">

                      {/* VARIANT HEADER */}
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="font-semibold">{variant.sku}</p>
                          <p className="text-sm text-gray-600">{variant.color} / {variant.size}</p>
                        </div>

                        <div className="flex items-center gap-3">
                          <button
                            className="text-green-600 text-lg leading-none"
                            title="Add Images"
                            onClick={() => {
                              setSelectedVariantId(variant.id);
                              setShowVariantImageUpload(true);
                            }}
                          >
                            +
                          </button>
                          <button
                            className="text-red-500 hover:text-red-700"
                            onClick={async () => {
                              if (!window.confirm("Delete this variant and all its designs?")) return;
                              await fetch(`/api/admin/variants/${variant.id}`, { method: "DELETE" });
                              await fetchProducts();

                              setShowAddVariant(false);

                              setNewVariant({
                                sku: "",
                                color: "",
                                size: ""
                              });
                            }}
                          >
                            <Trash2 size={16} />
                          </button>

                          <button
                            className="text-blue-600 text-sm"
                            onClick={() =>
                              setExpandedVariant(expandedVariant === variant.id ? null : variant.id)
                            }
                          >
                            {expandedVariant === variant.id ? "Hide Designs" : "Configure Designs"}
                          </button>
                        </div>
                      </div>


                      {/* ---------------- SELLABLE PRODUCTS ---------------- */}
                      {expandedVariant === variant.id && (
                        <div className="mt-4 space-y-3">

                          {variant.sellableProducts.map(sp => (
                            <GlassTile key={sp.id} className="p-4 bg-white/20">
                              <div className="flex justify-between ">
                                <div>
                                  <p className="font-medium">{sp.displayName}</p>
                                  <p className="text-sm text-gray-600">₹{sp.sellingPrice}</p>
                                </div>


                                <div className="flex items-center gap-3">
                                  <button
                                    className="text-red-500 hover:text-red-700"
                                    onClick={async () => {
                                      if (!window.confirm("Delete this sellable product?")) return;
                                      await fetch(`/api/admin/sellable-products/${sp.id}`, { method: "DELETE" });
                                      await fetchProducts();

                                      setShowAddSellable(false);
                                    }}
                                  >
                                    <Trash2 size={16} />
                                  </button>
                                </div>
                              </div>


                              {/* DESIGNS */}
                              <div className="mt-3 space-y-2">
                                {sp.designs.map(d => (
                                  <div
                                    key={d.id}
                                    className="flex justify-between text-sm bg-white/40 px-3 py-2 rounded-lg"
                                  >
                                    <span>{d.designName}</span>
                                    <span className="text-gray-600">
                                      {d.placementSku.toUpperCase()}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </GlassTile>
                          ))}

                          {/* ADD SELLABLE PRODUCT */}
                          <button
                            className="text-blue-600 text-sm mt-2"
                            onClick={() => {
                              setSelectedVariantId(variant.id);
                              setShowAddSellable(true);
                            }}
                          >
                            + Add Product Design
                          </button>

                        </div>
                      )}
                    </GlassTile>
                  ))}

                  {/* ADD VARIANT */}
                  <button
                    className="text-blue-600 text-sm"
                    onClick={() => {
                      setSelectedProductId(product.id);
                      setShowAddVariant(true);
                    }}
                  >
                    + Add Variant
                  </button>

                </div>
              )}
            </GlassTile>
          ))}

          {/* ---------------- ADD PRODUCT ---------------- */}
          <GlassTile className="p-6 border-dashed border-2 text-center">
            <button
              className="text-blue-600 font-semibold"
              onClick={() => setShowAddProduct(true)}
            >
              + Add New Product
            </button>
          </GlassTile>
          {/* ---------------- ADD DESIGN ---------------- */}
          <GlassTile className="p-6 border-dashed border-2 text-center">
            <button
              className="text-blue-600 font-semibold"
              onClick={() => setShowAddDesign(true)}
            >
              + Add New Design
            </button>
          </GlassTile>
        </div>
      </div>


      {showAddProduct && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center">

          <GlassTile className="w-full max-w-lg p-6">
            <h2 className="text-xl font-semibold mb-4">
              Add New Product
            </h2>

            <div className="space-y-4">

              {/* Product Name */}
              <div>
                <label className="text-sm font-medium">Product Name *</label>
                <input
                  className="w-full px-4 py-2 rounded-xl bg-white/60"
                  value={newProduct.productName}
                  onChange={e =>
                    setNewProduct({ ...newProduct, productName: e.target.value })
                  }
                />
                {errors.productName && (
                  <p className="text-red-500 text-sm">{errors.productName}</p>
                )}
              </div>

              {/* Product Code */}
              <div>
                <label className="text-sm font-medium">Product Code *</label>
                <input
                  className="w-full px-4 py-2 rounded-xl bg-white/60"
                  value={newProduct.productCode}
                  onChange={e =>
                    setNewProduct({
                      ...newProduct,
                      productCode: e.target.value.toUpperCase()
                    })
                  }
                />
                {errors.productCode && (
                  <p className="text-red-500 text-sm">{errors.productCode}</p>
                )}
              </div>

              {/* Product Type */}
              <div>
                <label className="text-sm font-medium">Product Type *</label>
                <select
                  className="w-full px-4 py-2 rounded-xl bg-white/60"
                  value={newProduct.productType}
                  onChange={e =>
                    setNewProduct({ ...newProduct, productType: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  <option value="COTTON_APPARELS">Cotton Apparels</option>
                  <option value="HOODIES">Hoodies</option>
                  <option value="ACCESSORIES">Accessories</option>
                </select>
                {errors.productType && (
                  <p className="text-red-500 text-sm">{errors.productType}</p>
                )}
              </div>
              {/* Product Category */}
              <div>
                <label className="text-sm font-medium">Product Category *</label>
                <select
                  className="w-full px-4 py-2 rounded-xl bg-white/60"
                  value={selectedCategory?.bit_value || ""}
                  onChange={(e) => {
                    const bitValue = parseInt(e.target.value, 10);
                    const category = categories.find(c => c.bit_value === bitValue);
                    setSelectedCategory(category);
                    setNewProduct({ ...newProduct, categoryId: bitValue }); 
                  }}
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.bit_value}>
                      {cat.name}
                    </option>
                  ))}
                </select>
                {errors.categoryId && (
                  <p className="text-red-500 text-sm">{errors.categoryId}</p>
                )}
              </div>

            </div>

            {/* Actions */}
            <div className="mt-6 flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-xl bg-gray-200"
                onClick={() => setShowAddProduct(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 rounded-xl bg-blue-600 text-white"
                onClick={async () => {
                  if (!validateProduct()) return;

                  await fetch("/api/admin/products", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(newProduct),
                  });

                  await fetchProducts();
                  setShowAddProduct(false);
                  setNewProduct({
                    productName: "",
                    productCode: "",
                    productType: "",
                    categoryId: "",
                  });
                }}
              >
                Create Product
              </button>
            </div>
          </GlassTile>
        </div>
      )}
      {showAddVariant && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center">

          <GlassTile className="w-full max-w-lg p-6">
            <h2 className="text-xl font-semibold mb-4">
              Add Product Variant
            </h2>

            <div className="space-y-4">

              {/* SKU */}
              <div>
                <label className="text-sm font-medium">Product SKU Code *</label>
                <input
                  className="w-full px-4 py-2 rounded-xl bg-white/60"
                  value={newVariant.sku}
                  onChange={e =>
                    setNewVariant({ ...newVariant, sku: e.target.value })
                  }
                />
                {variantErrors.sku && (
                  <p className="text-red-500 text-sm">{variantErrors.sku}</p>
                )}
              </div>

              {/* Color */}
              <div>
                <label className="text-sm font-medium">Color (optional)</label>
                <input
                  className="w-full px-4 py-2 rounded-xl bg-white/60"
                  placeholder="NA if empty"
                  value={newVariant.color}
                  onChange={e =>
                    setNewVariant({ ...newVariant, color: e.target.value })
                  }
                />
              </div>

              {/* Size */}
              <div>
                <label className="text-sm font-medium">Size (optional)</label>
                <input
                  className="w-full px-4 py-2 rounded-xl bg-white/60"
                  placeholder="NA if empty"
                  value={newVariant.size}
                  onChange={e =>
                    setNewVariant({ ...newVariant, size: e.target.value })
                  }
                />
              </div>

            </div>

            {/* Actions */}
            <div className="mt-6 flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-xl bg-gray-200"
                onClick={() => setShowAddVariant(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 rounded-xl bg-blue-600 text-white"
                onClick={async () => {
                  if (!validateVariant()) return;

                  await fetch(
                    `/api/admin/products/${selectedProductId}/variants`,
                    {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        sku: newVariant.sku,
                        color: newVariant.color || "NA",
                        size: newVariant.size || "NA"
                      }),
                    }
                  );

                  await fetchProducts();

                  setShowAddVariant(false);

                  setNewVariant({
                    sku: "",
                    color: "",
                    size: ""
                  });
                }}
              >
                Create Variant
              </button>
            </div>
          </GlassTile>
        </div>
      )}

      {showAddSellable && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center">

          <GlassTile className="w-full max-w-2xl p-6">
            <h2 className="text-xl font-semibold mb-4">
              Add Product Design
            </h2>

            {/* Display Name */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Display Name
              </label>
              <input
                className="w-full px-4 py-2.5 rounded-xl bg-white/60 focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={sellableForm.displayName}
                onChange={e =>
                  setSellableForm({ ...sellableForm, displayName: e.target.value })
                }
                placeholder="Auto-generated if empty"
              />
            </div>

            {/* Store SKU */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Store SKU
              </label>
              <input
                className="w-full px-4 py-2.5 rounded-xl bg-white/60 focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={sellableForm.storeSku}
                onChange={e =>
                  setSellableForm({ ...sellableForm, storeSku: e.target.value })
                }
                placeholder="Store SKU"
              />
            </div>

            {/* Selling Price */}
            <div className="mb-8">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Selling Price
              </label>
              <input
                className="w-full px-4 py-2.5 rounded-xl bg-white/60 focus:outline-none focus:ring-2 focus:ring-blue-400"
                value={sellableForm.sellingPrice}
                onChange={e =>
                  setSellableForm({ ...sellableForm, sellingPrice: e.target.value })
                }
                placeholder="Selling Price"
              />
            </div>


            {/* DESIGN ROWS */}
            <div className="space-y-3">
              {sellableForm.designs.map((row, index) => (
                <div key={index} className="flex gap-3">

                  {/* DESIGN DROPDOWN */}
                  <select
                    className="w-1/2 px-4 py-2 rounded-xl bg-white/60"
                    value={row.designId}
                    onChange={e => {
                      const copy = [...sellableForm.designs];
                      copy[index].designId = e.target.value;
                      setSellableForm({ ...sellableForm, designs: copy });
                    }}
                  >
                    <option value="">Select Design</option>
                    {designMaster.map(d => (
                      <option key={d.id} value={d.id}>
                        {d.designName}
                      </option>
                    ))}
                  </select>

                  {/* PLACEMENT DROPDOWN */}
                  <select
                    className="w-1/2 px-4 py-2 rounded-xl bg-white/60"
                    value={row.placement}
                    onChange={e => {
                      const copy = [...sellableForm.designs];
                      copy[index].placement = e.target.value;
                      setSellableForm({ ...sellableForm, designs: copy });
                    }}
                  >
                    <option value="">Select Placement</option>
                    {PLACEMENTS.map(p => (
                      <option
                        key={p.value}
                        value={p.value}
                        disabled={
                          usedPlacements.includes(p.value) &&
                          row.placement !== p.value
                        }
                      >
                        {p.label}
                      </option>
                    ))}
                  </select>

                </div>
              ))}
            </div>

            {/* ADD DESIGN */}
            <button
              className="text-blue-600 text-sm mt-3"
              onClick={addDesignRow}
            >
              + Add Design
            </button>

            {/* ACTIONS */}
            <div className="mt-6 flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-xl bg-gray-200"
                onClick={() => setShowAddSellable(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 rounded-xl bg-blue-600 text-white"
                onClick={async () => {
                  const finalDisplayName =
                    sellableForm.displayName || generateDisplayName();

                  await fetch("/api/admin/sellable-products", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      variantId: selectedVariantId,
                      displayName: finalDisplayName,
                      sellingPrice: sellableForm.sellingPrice,
                      storeSku: sellableForm.storeSku,
                      designs: sellableForm.designs.map(d => ({
                        designId: d.designId,
                        placementSku: d.placement
                      }))
                    }),
                  });
                  console.log(sellableForm);
                  await fetchProducts();
                  setShowAddSellable(false);

                }}
              >
                Create Sellable Product
              </button>
            </div>
          </GlassTile>
        </div>
      )}
      {showAddDesign && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center">

          <GlassTile className="w-full max-w-lg p-6">
            <h2 className="text-xl font-semibold mb-4">
              Add New Design
            </h2>

            <div className="space-y-4">

              {/* Design Name */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Design Name *
                </label>
                <input
                  className="w-full px-4 py-2.5 rounded-xl bg-white/60"
                  value={newDesign.designName}
                  onChange={e =>
                    setNewDesign({ ...newDesign, designName: e.target.value })
                  }
                />
                {designErrors.designName && (
                  <p className="text-red-500 text-sm">{designErrors.designName}</p>
                )}
              </div>

              {/* Design Code */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Design Code *
                </label>
                <input
                  className="w-full px-4 py-2.5 rounded-xl bg-white/60"
                  value={newDesign.designCode}
                  onChange={e =>
                    setNewDesign({
                      ...newDesign,
                      designCode: e.target.value
                    })
                  }
                />
                {designErrors.designCode && (
                  <p className="text-red-500 text-sm">{designErrors.designCode}</p>
                )}
              </div>
            </div>

            {/* ACTIONS */}
            <div className="mt-6 flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-xl bg-gray-200"
                onClick={() => setShowAddDesign(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 rounded-xl bg-blue-600 text-white"
                onClick={async () => {

                  await fetch("/api/admin/designs", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(newDesign)
                  });

                  const res = await fetch("/api/admin/designs");
                  const data = await res.json();

                  setDesignMaster(data);

                  setShowAddDesign(false);

                  setNewDesign({
                    designName: "",
                    designCode: ""
                  });
                }}
              >
                Create Design
              </button>
            </div>
          </GlassTile>
        </div>
      )}
      {showVariantImageUpload && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center">
          <GlassTile className="w-full max-w-lg p-6">
            <h2 className="text-xl font-semibold mb-4">
              Upload Variant Images
            </h2>

            <input
              type="file"
              multiple
              accept="image/*"
              className="mb-4"
              onChange={e => setVariantImageFiles([...e.target.files])}
            />

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 rounded-xl bg-gray-200"
                onClick={() => setShowVariantImageUpload(false)}
              >
                Cancel
              </button>

              <button
                className="px-4 py-2 rounded-xl bg-blue-600 text-white"
                onClick={async () => {
                  try {
                    const formData = new FormData();
                    variantImageFiles.forEach(f =>
                      formData.append("files", f)
                    );

                    const response = await fetch(
                      `/api/admin/variants/${selectedVariantId}/images`,
                      {
                        method: "POST",
                        body: formData,
                      }
                    );

                    if (!response.ok) {
                      throw new Error(`Upload failed with status: ${response.status}`);
                    }

                    console.log("Variant images uploaded successfully");
                    await fetchProducts();
                    setShowVariantImageUpload(false);
                    setVariantImageFiles([]);

                  } catch (error) {
                    console.error("Variant image upload failed:", error);
                    // You might want to show a user-friendly error message here
                    // For example: setErrorMessage("Failed to upload images. Please try again.");
                  }
                }}
              >
                Upload
              </button>
            </div>
          </GlassTile>
        </div>
      )}
    </>
  );
}
